import React from 'react'

const Footer = () => {
    return (


        <div className="footer">
            <div className="container">
                <div uk-grid="">
                    <div className="uk-width-1-3@m">
                        <a href="home.html" className="uk-logo">
                            <i className="uil-graduation-hat"> </i>
                            Leo Techs Academy
                        </a>
                        <p className="footer-description"> Apprenez à coder où que vous soyez grâce à Léo Techs Academy</p>
                    </div>
                    <div className="uk-width-expand@s uk-width-1-2">
                        <div className="footer-links pl-lg-8">
                            <h5>Explore </h5>
                            <ul>
                                <li><a href="course-card.html"> Courses </a></li>
                                <li><a href="course-path.html"> Track </a></li>
                                <li><a href="blog-card.html"> Blog </a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="uk-width-expand@s uk-width-1-2">
                        <div className="footer-links pl-lg-8">
                            <h5> Mon compte </h5>
                            <ul>
                                <li><a href="profile-1.html"> Profil </a></li>
                                <li><a href="#"> Paramètres </a></li>
                                <li><a href="#"> Projets </a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="uk-width-expand@s uk-width-1-2">
                        <div className="footer-links pl-lg-8">
                            <h5> Resources</h5>
                            <ul>
                                <li><a href="#"> Contacts </a></li>
                                <li><a href="page-Privacy.html"> Privacy Policy </a></li>
                                <li><a href="page-term.html"> Terms of Use </a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="uk-grid-collapse" uk-grid="">
                    <div className="uk-width-expand@s uk-first-column">
                        <p>© 2020 <strong>Léo Tech's</strong>. Tous droits reservés. </p>
                    </div>
                    <div className="uk-width-auto@s">
                        <nav className="footer-nav-icon">
                            <ul>
                                <li><a href="#"><i className="icon-brand-facebook"></i></a></li>
                                <li><a href="#"><i className="icon-brand-dribbble"></i></a></li>
                                <li><a href="#"><i className="icon-brand-youtube"></i></a></li>
                                <li><a href="#"><i className="icon-brand-twitter"></i></a></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
